import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface ContactRequest {
  phone?: string,
  mobile?: string,
  email?: string,
  address?: string,
  location?: object,
  socials?: Array<object>,
  city_id?: number | null,
}
export const contactInfoApi = createApi({
  reducerPath: 'contactInfoApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/site-contact',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['site-contact'],

  endpoints: (builder) => ({
    getContactInfo: builder.query({
      query: () => 'view',
      providesTags: ['site-contact']
    }),
    editContactInfo: builder.mutation<boolean, ContactRequest>({
      query: (data) => ({
        url: 'edit',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['site-contact']
    }),
  }),
})

export const { useGetContactInfoQuery, useEditContactInfoMutation } = contactInfoApi